// extracted by mini-css-extract-plugin
export default {"list":"ContactsList_list__jDQ-H"};